import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import Layers from "slotworks/graphics/layers/layers";
import RevolverWinTransitions from "./revolver-win-transitions";
import Timer from "slotworks/utils/timer";
import { parallel, sequence } from "slotworks/utils/race-utils";
import { BounceZoomIn, FadeOut, FadeIn, ZoomOut, EndlessHover } from "slotworks/graphics/animation/base-animations";
import Point from "slotworks/utils/geom/point";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";
import { StartBaseMusic } from "commands/music";

export default class BigWinTransitions extends RevolverWinTransitions {
    public EXPLOSION_TIME: number = 400;
    public TEXT_ZOOM = 1.1;
    public TEXT_ZOOM_TWEEN = 0.95;
    public big: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.resetEverything();           

            this.big = Layers.CelebrationContent.getSprite("big");
            Layers.CelebrationForeground.moveBehind(Layers.CelebrationContent);
            this.big.visible = false;
            RevolverWinTransitions.winValue.visible = false;

            this.inResolve = resolve;
            FadeIn(RevolverWinTransitions.background, this.BOUNCE_TIME).execute();
            this.explodeEmitter(RevolverWinTransitions.glitter, 350);
            this.zoomInStacks().execute();
            RevolverWinTransitions.setOrientationChange();
            RevolverWinTransitions.currentTiers = this.getSelectedTiers();
            const tiers = RevolverWinTransitions.currentTiers.length;
            let wintype = [
                'big',
                'mega',
                'supermega',
                'epic'
            ];

            setTimeout(() =>
                parallel([
                    () => Contract.wrap(() => { soundManager.customEvent(`${wintype[tiers - 1]}_win`) }),
                    () => this.zoomTextIn(1, 0.9),
                    () => this.titleIn(this.big, new Point(0.5, 1))
                ]).then(() => {
                    if (tiers > 1)
                        this.hoverTitleBigWin(this.big, 2);
                    else
                        this.endlessHover(this.big);
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    new TweenJS.Tween(RevolverWinTransitions.winValue.scale)
                        .to({ x: this.TEXT_ZOOM, y: this.TEXT_ZOOM }, 1000)
                        .yoyo(true)
                        .repeat(Infinity)
                        .start();
                    this.resolveIn();
                }), 200);
        });
    }

    public skipIn() {
        soundManager.customEvent("big_win");
        this.endlessHover(this.big);
        this.big.visible = true;
        RevolverWinTransitions.winValue.visible = true;
        this.setTextSize(this.TEXT_ZOOM);
        this.resolveIn();
    }

    public out(): Contract<void> {
        RevolverWinTransitions.removeOrientationChange();
        return parallel([
            () => this.zoomOutStacks(),
            () => sequence([
                () => Contract.wrap(() => {
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    const totalWin = gameState.getCurrentGame().totalCreditsWon;
                    Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
                    soundManager.customEvent("plaque_transition");
                }),
                () => parallel([
                    () => ZoomOut(RevolverWinTransitions.winValue, 50),
                    () => this.titleOut(this.big, new Point(0.5, 1), 50)
                ]),
                () => Contract.wrap(() => {
                    TweenJS.removeAll(this.big.scale);
                    TweenJS.removeAll(this.big);
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    this.big.visible = false;
                    soundManager.customEvent("celebration_end");
                    // soundManager.customEvent("base_reels_background_start");
                    StartBaseMusic(true);
                }),
                () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
                () => Contract.getTimeoutContract(750)
            ])
        ]);
    }

    public destroy() {
        this.clearTimers();

        super.destroy();
    }

}